"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
const useOrganizations = () => {
    const fetchFunc = () => axios.get('/api/get-organizations').then((response) => response.data.data);
    return (0, react_query_1.useQuery)({
        queryKey: ['get-organizations'],
        queryFn: fetchFunc,
    });
};
exports.default = useOrganizations;
